export const getCurrentPath = state =>
    state.Nav.currentPath;

export const getHistory = state => 
    state.Nav.history;